<template>
    <div class="col backgroundForm">
        <div class="col-12 col-md-10 offset-md-1">
            <h3 class="col" align="center">Renovacion de Matriculas </h3>
            <button class="btn btn-danger col-m-12 col-md-2 offset-md-10" @click="mUpdateRenew"><font-awesome-icon icon="sync-alt" /></button>
            <form @submit.prevent="searchExpiration">

                <div class="form-row">
                    <div class="form-group col offset-md-3 col-md-6">
                        <label for="captain_download" class="badge badge-info">CAPITANIA</label>
                            <select name="captain_download" class="form-control" id="captain_download" v-model="port_select" @change="mClearResults">
                                <option v-for="port in port_local" :value="port" :key="port.id">{{ port.name_port }}</option>
                            </select>
                    </div>
                </div>

                <button class="btn btn-outline-primary col col-md-4 offset-md-4"><font-awesome-icon icon="list" /> Listar</button>
            </form>
        </div>
        <br>
        <transition name="fade" mode="out-in">
            <div v-if="filter_input" class="form-group has-search">
                <!-- <span class="fa fa-search form-control-feedback"></span> -->
                <font-awesome-icon icon="search" class="fa-search form-control-feedback" />
                <input type="text" class="form-control" placeholder="Busqueda" v-model="value_filter">
            </div>
        </transition>
        {{ cValueFilter }}
        <transition name="fade" mode="out-in">
        <div v-if="renew_local_status">           
            <div class="table-responsive">
                <table class="table">
                    <thead class="thead-dark">
                        <tr>
                            <th colspan="6" align="center">{{ port_select.name_port }}</th>
                        </tr>
                        <tr>
                            <th>#</th>
                            <th scoped="col">Matricula</th>
                            <th scoped="col" class="d-none d-md-block">Nombre Nave</th>
                            <th scoped="col">Vencimiento</th>
                            <th scoped="col">Ver</th>
                            <th scoped="col">Seleccionar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(boat, index) in renew_local" :key="boat.id">
                            <td>{{ index+1 }}</td>
                            <td>
                                <div v-if="boat.enrollment">{{ boat.enrollment }}</div>
                                <div v-else>{{ boat.old_enrollment }}</div>
                            </td>                            
                            <td class="d-none d-md-block">{{ boat.name }}</td>
                            <td>{{ boat.date_expiration }}</td>
                            <td>
                                <button class="btn btn-warning" @click="mViewDetail(boat)"><font-awesome-icon icon="eye" ></font-awesome-icon></button>
                            </td>
                            <td align="center">                           
                                <button class="btn btn-success" @click="mDischargeRenew(boat)"><font-awesome-icon icon="check"></font-awesome-icon></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        </transition>
        <modal-view :idModalView="idModalV" :title="titleModalV" :content="contentModalV"></modal-view>
        <modal-loading :id-modal="id_modal_l" :title="load_title" :status-send="load_status"></modal-loading>
    </div>
</template>

<script>
import axios from 'axios';
import Vue from 'vue';

import modalView from '../modal/modalView';
import modalLoading from '../modal/modalLoading'

export default {
    name:'renew',
    data(){
        return{
            id_modal_l:'modalUpdateR',
            load_title:'Actualizando',
            load_status:true,
            port_local:[],
            port_select:{
                id:0
            },
            renew_local:null,
            dRolUser:false,
            filterShips:[],
            idModalV:'viewDtsShip',
            titleModalV:null,
            contentModalV:null,
            filter_input:false,
            renew_local_status:false,
            value_filter:''
        }
    },
    mounted(){
        this.chargeInit()
    },
    methods:{
        async mUpdateRenew(){
            this.mShowModal(this.id_modal_l);
            try {
                let upre=await axios.get(`updateVigency?api_token=${Vue.auth.getToken()}`);
                console.log(upre);
                if(upre.data[0].status){
                    toastr.info(upre.data[0].respuesta, 'Exito');
                }else{
                    toastr.error(upre.data[0].respuesta, 'Error');
                }    
            } catch (error) {
                toastr.error('Error 001 Update', 'Error');
                setTimeout(()=>{
                    this.mHideModal(this.id_modal_l);
                },1000)
            }
            
            setTimeout(()=>{
                this.mHideModal(this.id_modal_l);
            },1000)
        },
        mClearResults(){
            this.renew_local=[];
            this.renew_local_status=false;
            this.filter_input=false;
        },
        async searchExpiration(){
            let auxPort=0;
            this.debts_local=null;
            this.renew_local=[];
            if(this.port_select.id > 0){
                // auxPort=this.dRolUser ? this.port_select.id : this.cSessionUser.portId;
                try {
                    // let ships_renew= await axios.get(`getPendingRenew/${auxPort}`);
                    let ships_renew= await axios.get(`getPendingRenew/${this.port_select.id}?api_token=${Vue.auth.getToken()}`);
                    console.log(ships_renew);
                    if(ships_renew.data.length > 0 && ships_renew.data.length >= 21 ){
                        // habilitar el formulario de filtro de datos
                        let dts=ships_renew.data;
                        
                        this.renew_local=dts;
                        this.filterShips=dts;
                        this.filter_input=true;
                        this.renew_local_status=true;
                        
                    }else if(ships_renew.data.length > 0 && ships_renew.data.length <= 20 ){
                        // let auxDeb=ships_renew.data[0];
                        // this.debts_local=debts.data;
                        this.filter_input=false;
                        this.renew_local=ships_renew.data;
                        this.renew_local_status=true;
                    }else{
                        toastr.info('No existen Pendientes', 'Sin Registro');
                    }
                } catch (error) {
                    console.log(error);
                    toastr.info('No existen Pendientes', 'Sin Registro');
                }
            }else{
                toastr.info('Verifique que los campos esten completos', 'Advertencia')
            }
        },
        async chargeInit(){
            //   llamar al loading hasta esperar que complete todos los datos del formulario hacer lo mismo en la aprobacion de la matricula

            // const ports = await axios.get(`getPorts`);
            const ports = await axios.get(`getPorts?api_token=${Vue.auth.getToken()}`);
            this.port_local=ports.data;            

            this.dRolUser= this.cSessionUser.role === 3 ? true:false;
        },
        mSelectShip(){
            // console.log('pasando a la siguiente ventana');
            this.$router.push('discharge-document');
        },
        mViewDetail(data){
            
            let enroll=data.enrollment ? data.enrollment : data.old_enrollment;
            this.titleModalV=data.name;
            this.contentModalV=` 
                <div class="form-group">
                    <label for="enrollment">Matricula</label>
                    <input type="text" class="form-control" disabled value="${enroll}" />
                </div>
                <div class="form-group">
                    <label for="enrollment">Tipo</label>
                    <input type="text" class="form-control" disabled value="${data.type_ship}" />
                </div>
                <div class="form-row">
                    <div class="col-12 col-md-6">
                        <label for="enrollment">TRB</label>
                        <input type="text" class="form-control" disabled value="${data.trb}" />
                    </div>
                    <div class="col-12 col-md-6">
                        <label for="enrollment">TRN</label>
                        <input type="text" class="form-control" disabled value="${data.trn}" />
                    </div>
                </div>
                <div class="form-group">
                    <label for="enrollment">Fecha de Expiracion</label>
                    <input type="text" class="form-control" disabled value="${data.date_expiration}" />
                </div>
                
            `;
            this.mShowModal(this.idModalV);
        },
        mDischargeRenew(data){
            // console.log(data)
            this.$store.dispatch('sShipRenew/addShipRenew', data);
            this.$router.push('send-renew');
        },
        mShowModal(id){
            $('#'+id).modal('show');
        },
        mHideModal(id){
            $('#'+id).modal('hide');
        }
    },
    computed:{
        cSessionUser(){
            return this.$store.getters.getUserState;
        },
        cValueFilter(){
            // console.log(this.value_filter);
            // this.filterShips=ships_renew.data[0];
            this.renew_local=null;
            
            let v=this.value_filter;
            // aca ver si el filtro tiene mas de dos caracteres recien filtar sino vaciar todo

            if(this.value_filter !== '' || this.value_filter !== null){
                let auxArray=[];
                
                this.filterShips.forEach(function(e, index){
                    
                    
                    let existEnroll;
                    let existName;

                    let enroll=e.enrollment ? e.enrollment : e.old_enrollment;
                    
                    let name=e.name;

                    existEnroll=enroll.indexOf(v.toUpperCase());
                    existName=name.indexOf(v.toUpperCase());

                    if(existEnroll > -1 || existName > -1){
                        let auxDebs={
                            date_expiration: e.date_expiration,
                            enrollment: e.enrollment,
                            id_expiration: e.id_expiration,
                            id_ship: e.id_ship,
                            name: e.name,
                            old_enrollment: e.old_enrollment,
                            trb: e.trb,
                            trn: e.trn,
                            type_ship: e.type_ship
                        }
                        auxArray.push(auxDebs);                        
                    }
                })
                this.renew_local=auxArray;
            }else if(this.filterShips.length >= 1){
                // console.log('llegando aqui')
                this.renew_local=this.filterShips;
            }else{
                // console.log('no tiene nada')
                this.renew_local=null;
            }
            // this.renew_local=auxArray;
            // let auxDeb=ships_renew.data[0];
            
            // this.renew_local=ships_renew.data;
        }
    },
    components:{
        'modal-view':modalView,
        'modal-loading':modalLoading
    }
}
</script>

<style>
.has-search .form-control {
    padding-left: 2.375rem;
}

.has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
}
</style>




// WEBPACK FOOTER //
// src/components/renew/Renew.vue